module.exports = __webpack_public_path__ + "img/icon-bg4.2041d923.png";